import { render, staticRenderFns } from "./datauppk.vue?vue&type=template&id=2e5fcc16&"
import script from "./datauppk.vue?vue&type=script&lang=js&"
export * from "./datauppk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports